/// <reference path="input.ts" />

/**
 * <dl>
 * <dt>属性</dt>
 * <dd>secret: 入力内容が隠蔽されます</dd>
 * <dd>type: inputのtype属性に設定されます</dd>
 * <dd>invalid: 設定値がpattern属性に違反する場合に設定されます</dd>
 * </dl>
 * その他の属性はKoyoriInputに依存します。
 */
class KoyoriInputText extends KoyoriInput {

	static get observedAttributes() {
		return ['label', 'message', 'secret'].concat(this.inputAttributes);
	}

	static get inputAttributes() {
		return ['value', 'name', 'type', 'step', 'disabled', 'autocomplete', 'list', 'maxlength', 'pattern', 'placeholder', 'readonly', 'inputmode'];
	}

	constructor() {
		super();

		let element = <HTMLInputElement>this.inputElement;
		this.inputElement.addEventListener('keyup', () => {
			if (this.validate(element.value)) {
				this.removeAttribute('invalid');
			} else {
				this.setAttribute('invalid', '');
			}
		});
		this.inputElement.addEventListener('blur', () => {
			if (this.validate(element.value)) {
				this.removeAttribute('invalid');
			} else {
				this.setAttribute('invalid', '');
			}
		});
	}

	connectedCallback(): void {
		super.connectedCallback();

		if (this.validate((<HTMLInputElement>this.inputElement).value)) {
			this.removeAttribute('invalid');
		} else {
			this.setAttribute('invalid', '');
		}
	}

		/**
	 * @return 設定されている値
	 */
	get value(): string {
		let value = (<HTMLInputElement>this.inputElement).value;
		if (this.inputElement.getAttribute('type') == 'date') {
			value = value.replace(/-/g, '/');
		} else if (this.inputElement.getAttribute('type') == 'datetime-local') {
			value = value.replace(/-/g, '/').replace('T', ' ');
		}
		return value;
	}

	/**
	 * @param value 設定する値
	 */
	set value(value: string) {
		if (value) {
			if (this.inputElement.getAttribute('type') == 'date') {
				value = value.replace(/\//g, '-');
			} else if (this.inputElement.getAttribute('type') == 'datetime-local') {
				value = value.replace(/\//g, '-').replace(' ', 'T');
			}
		}
		(<HTMLInputElement>this.inputElement).value = value;
	}

	/**
	 * @return 変更イベントを取得する属性のリスト
	 */
	protected getObservedAttributes(): string[] {
		return KoyoriInputText.observedAttributes;
	}

	/**
	 * @return inputタグに設定する属性のリスト
	 */
	protected getInputAttributes(): string[] {
		return KoyoriInputText.inputAttributes;
	}

	/**
	 * 設定値が正しいか判定します。
	 * 
	 * @param value 設定値
	 * @return 正しい場合はtrue
	 */
	protected validate(value: string): boolean {
		let pattern = this.getAttribute('pattern');
		if (pattern != null && pattern != '') {
			return new RegExp(pattern).test(value);
		} else {
			return true;
		}
	}

	/**
	 * @return inputタグのtype属性の値
	 */
	protected getInputType(): string {
		if (this.getAttribute('secret') == null) {
			return 'text';
		} else {
			return 'password';
		}
	}

	protected secretChanged(value: string): void {
		if (value == null) {
			this.inputElement.setAttribute('type', 'text');
		} else {
			this.inputElement.setAttribute('type', 'password');
		}
	}

}
window.customElements.define('koy-input-text', KoyoriInputText);
